import React from "react";

import styles from "./SubscribeStreamCapSuccess.css";

export default class SubscribeStreamCapSuccess extends React.Component {
  constructor() {
    super();

    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.focus();
  }

  render() {
    return (
      <div className={styles.root} ref={this.ref} tabIndex="-1">
        <h4 className={styles.title}>1 quick thing:</h4>
        <p className={styles.content}>
          Check your email to confirm your subscription
        </p>
      </div>
    );
  }
}
